interface PageTitleProps {
  title: string
  subtitle?: string
}

export function PageTitle({ title, subtitle }: PageTitleProps) {
  return (
    <div>
      <h1 className="font-display text-center text-2xl tracking-widest uppercase text-ink">
        {title}
      </h1>
      {subtitle && (
        <p className="text-frame italic text-sm mt-xs text-center">
          {subtitle}
        </p>
      )}
    </div>
  )
}
